const defaultRouters = [
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/register/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue')
  },
  {
    path: '/licenseExpire',
    name: 'licenseExpire',
    component: () => import(/* webpackChunkName: "licenseExpire" */ '../views/licenseExpire/index.vue')
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/errorPage/404.vue')
  }
];

export default defaultRouters;
